import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { cva, type VariantProps } from "class-variance-authority";
import { forwardRef } from "react";

const golfButtonVariants = cva(
  "font-semibold transition-all duration-200 active:scale-[0.98] disabled:opacity-50 disabled:pointer-events-none",
  {
    variants: {
      variant: {
        primary: "btn-golf-primary",
        secondary: "btn-golf-secondary",
        outline: "border-2 border-border bg-transparent hover:bg-muted",
        ghost: "hover:bg-muted/50",
      },
      size: {
        default: "px-6 py-3 rounded-xl",
        sm: "px-4 py-2 rounded-lg text-sm",
        lg: "px-8 py-4 rounded-xl text-lg",
        icon: "w-12 h-12 rounded-xl",
      },
    },
    defaultVariants: {
      variant: "primary",
      size: "default",
    },
  }
);

export interface GolfButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof golfButtonVariants> {}

const GolfButton = forwardRef<HTMLButtonElement, GolfButtonProps>(
  ({ className, variant, size, ...props }, ref) => {
    return (
      <button
        className={cn(golfButtonVariants({ variant, size, className }))}
        ref={ref}
        {...props}
      />
    );
  }
);
GolfButton.displayName = "GolfButton";

export { GolfButton, golfButtonVariants };